import React, { useEffect, useState } from 'react';
import { Button, Card, ProgressBar, Spinner } from 'react-bootstrap-v5';
import { useAuth } from '../../../contexts/CustomContextHook/useAuth';
import { useHistory } from 'react-router-dom';
import { Calendar, Toolbar, momentLocalizer, Views } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import FullPageLoader from '../../../modules/FullPageLoader';
import { MixedWidget10, MixedWidget11, MixedWidget2, MixedWidget8 } from '../../../../_metronic/partials/widgets';
import { StatisticsWidget5 } from '../../../../_metronic/partials/widgets/statistics/StatisticsWidget5';
import axios, { API_URL } from '../../../../setup/axios/axios';
import 'react-datepicker/dist/react-datepicker.css'
import DateView from 'react-datepicker'

// Custom Month View Component
const CustomMonthView = ({ events, date }) => {
  const startOfMonth = moment(date).startOf('month');
  const endOfMonth = moment(date).endOf('month');

  const history = useHistory()

  const weeks = [];

  for (let week = startOfMonth.clone().startOf('week'); week.isBefore(endOfMonth); week.add(1, 'week')) {
    weeks.push(week.clone());
  }

  const daysInWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ display: 'flex', borderTop: '1px solid #ddd', flexDirection: 'row', borderBottom: '1px solid #ddd' }}>
        {daysInWeek.map(day => (
          <div key={day} className='fs-5 fw-bold' style={{ flex: 1, padding: '10px', borderLeft: '1px solid #ddd', borderRight: '1px solid #ddd', textAlign: 'center' }}>
            {day}
          </div>
        ))}
      </div>

      {weeks.map(week => (
        <div key={week} style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
          {Array(7).fill(0).map((_, index) => {
            const day = week.clone().add(index, 'days');
            const dayEvents = events.filter(event => moment(new Date(event.start)).isSame(day, 'day'));

            return (
              <div key={index} style={{ flex: 1, borderLeft: '1px solid #ddd', borderRight: '1px solid #ddd', borderBottom: '1px solid #ddd', position: 'relative' }}>
                <div style={{ position: 'absolute', top: '5px', left: '5px' }} className='fs-4'>
                  {day.date()}
                </div>
                <div style={{ marginLeft: 2, display: '', padding: '2px', marginTop: 25 }}>
                  {['morning', 'lunch', 'dinner'].map(mealType => (
                    <div className='mt-1' key={mealType}>
                      {dayEvents.map(event =>
                        event.dashboardMeals.filter(a => a.type.toLowerCase() === mealType).map((meals, idx) => {
                          const progressPercen = ((meals.booked_cap / event.total_cap) * 100).toFixed(0);
                          return (
                            <div className='flex   border border-bottom-2' key={idx} >
                              {progressPercen !== '0' && (
                                <ProgressBar
                                  now={progressPercen}
                                  variant="danger"
                                  label={`${meals.booked_cap}`}
                                />
                              )}
                              <div style={{ display: 'inline-flex' }} className='mb-2 mt-2'>
                                <span className='text-center fs-8 mx-1'>{mealType.charAt(0).toUpperCase()}</span>
                                {meals.dashboardHalls.map(meal => {
                                  const isInquiry = meal.status === 'Inquiry';
                                  const isTentative = meal.status === 'Tentative';
                                  const isConfirmed = meal.status === 'Confirmed';

                                  return (
                                    <div key={meal.title}
                                      className={`${isConfirmed ? 'bg-primary text-white'
                                        : isInquiry ? 'bg-info text-white'
                                          : isTentative ? 'bg-warning text white'
                                            : 'bg-success text-white'} text-center fs-9 rounded mx-1`}
                                      style={{
                                        cursor: 'pointer',
                                        width: '30px',
                                        padding: '2px'
                                      }}
                                      onClick={() => {
                                        if (meal.status != null) {
                                          if (meal.status.toLowerCase() == "confirmed") {
                                            history.push(`/bookings/details/${meal.bookingId}`)
                                          }
                                        }
                                        else {
                                          history.push(`/bookings/create?date=${event.start}`)

                                          // alert(JSON.stringify(event.end))
                                        }
                                      }}
                                    >
                                      {meal.title}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

// Custom Month View Wrapper with static methods
const CustomMonthViewWrapper = (props) => {

  const { date, events } = props;
  return <CustomMonthView events={events} date={date} />;
};

CustomMonthViewWrapper.title = (date, { localizer }) => localizer.format(date, 'monthHeaderFormat');
CustomMonthViewWrapper.range = (date) => {
  const start = moment(date).startOf('month').startOf('week');
  const end = moment(date).endOf('month').endOf('week');
  const range = [];
  for (let day = start; day.isBefore(end); day.add(1, 'day')) {
    range.push(day.clone().toDate());
  }
  return range;
};

// Dashboard Component
const DashboardComponent = () => {
  const [loading, setLoading] = useState(false);
  const { UserToken } = useAuth();
  const localizer = momentLocalizer(moment);
  const [dashboradData, setDashboradData] = useState([]);
  const history = useHistory();
  const [currentDate, setCurrentDate] = useState(new Date());

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const now = new Date();
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const res = await axios.get(`${API_URL}/api/Booking/DashboardBookings/${startOfMonth.toDateString()}`);
        setDashboradData(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSelectEvent = (event) => {
    alert(JSON.stringify(event));
  };

  const handleSelectSlot = (slotInfo) => {
    history.push('/Bookings/create', { date: slotInfo.end });
  };

  const eventPropGetter = (event) => ({
    style: { backgroundColor: event.color },
  });






  const CustomToolbar = (toolbar) => {

    return (
      <div className="rbc-toolbar" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span className="rbc-btn-group" style={{ display: 'flex', alignItems: 'center' }}>
          {/* <button type="button" className='mx-1 rounded' onClick={handleTodayClick}>Today</button> */}
          {/* <button type="button" onClick={handleBackClick}>Back</button>
        <button type="button" onClick={handleNextClick}>Next</button> */}
          {/* <select className=' form-select form-select mx-1 ' onChange={handleMonthChange} value={currentDate.getMonth()}>
          {moment.months().map((month, index) => (
            <option key={index} value={index}>{month}</option>
          ))}
        </select> */}

          <DateView className='form-control'
            showMonthYearPicker
            dateFormat="MM/yyyy"
            selected={currentDate} onChange={handleMonthChange}
          // onChange={(date) => setMonth(date)}
          />

        </span>
        <span className="rbc-toolbar-label">{toolbar.label}</span>
      </div>
    )
  };
  const handleMonthChange = async (date) => {
    console.log('date : ', date);

    setCurrentDate(date);

    const selectedDate = new Date(date);


    
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/api/Booking/DashboardBookings/${selectedDate.toDateString()}`);
      setDashboradData(res.data);
      // setCurrentDate(newDate);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      {loading && <FullPageLoader />}
      
    
      <div className='flex-wrap ' >
        <div className='d-flex flex-column'>
          <div className='d-flex flex-row justify-content-end'>
            {['Confirm', 'Tentative', 'Inquiry', 'Free']
              .map((status, index) => (
                <div className='mx-1 d-flex flex-row' key={status}>
                  <span className='fs-6 mx-1'>{status}</span>
                  <div className={`bg-${index === 0 ? 'primary' : index === 1 ? 'warning' : index === 2 ? 'info' : 'success'} 
                p-3 w-100px h-5px rounded`}></div>
                </div>
              ))}
          </div>
        </div>

        <Calendar
          localizer={localizer}
          events={dashboradData}
          startAccessor="start"
          endAccessor="end"
          views={{ month: CustomMonthViewWrapper }}
          defaultView={Views.MONTH}
          eventPropGetter={eventPropGetter}
          onSelectEvent={handleSelectEvent}
          selectable
          onSelectSlot={handleSelectSlot}
          components={{ toolbar: CustomToolbar }}
          date={currentDate}
          className='bg-white p-3'
        />
      </div>
    </div>
  );
};

export default DashboardComponent;
